import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/our-comprehensive-program/about-dr-fitzer/")({
  server: {
    handlers: {
      GET: async () => {
        return new Response(null, {
          status: 301,
          headers: {
            Location: "/about",
          },
        });
      },
    },
  },
  component: () => null,
});
